<template>
  <ts-loading-banner :loading="waiting">
    <div class="tw-space-y-4">
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{ $t("courseSkill.skill") }}</label>
          <a-select
            class="col-md-12"
            show-search
            option-filter-prop="children"
            allowClear
            v-model.number.trim="model.level_skill_id"
            :class="{
              'is-invalid': errors.has('level_skill_id'),
            }"
          >
            <a-select-option
              v-for="(skill, index) in formViewDatas['levelSkills']"
              :key="index"
              :value="skill.level_skill_id"
            >
              {{ skill.level_skill_name }} | Skill: {{ skill.skill_name_en }}|
              LeveL:
              {{ skill.skill_level_order }}
              <span
                v-if="skill.is_accessor"
                class="badge bg-primary mr-2 tw-capitalize"
              >
                Accessor</span
              >
            </a-select-option>
          </a-select>
          <div class="invalid-feedback" v-if="errors.has('level_skill_id')">
            {{ errors.first("level_skill_id") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{
            $t("courseSkill.examinationEvent")
          }}</label>
          <input
            v-model="model.examination_event"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('examination_event') }"
            :placeholder="$t('courseSkill.examinationEvent')"
          />
          <div class="invalid-feedback" v-if="errors.has('examination_event')">
            {{ errors.first("examination_event") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label>{{ $t("courseSkill.room") }}</label>
          <input
            v-model="model.room"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('room') }"
            :placeholder="$t('courseSkill.room')"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{ $t("courseSkill.trainer") }}</label>
          <a-select
            class="col-md-12"
            show-search
            option-filter-prop="children"
            allowClear
            v-model.number.trim="model.trainer_id"
            :class="{
              'is-invalid': errors.has('trainer_id'),
            }"
          >
            <a-select-option
              v-for="(trainer, index) in trainers1"
              :key="index"
              :value="trainer.trainer_id"
            >
              {{ trainer.full_name_en }}
            </a-select-option>
          </a-select>
          <div class="invalid-feedback" v-if="errors.has('trainer_id')">
            {{ errors.first("trainer_id") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label>{{ $t("courseSkill.trainer2") }}</label>
          <a-select
            class="col-md-12"
            show-search
            option-filter-prop="children"
            allowClear
            v-model.number.trim="model.trainer_id_2"
            :class="{
              'is-invalid': errors.has('trainer_id_2'),
            }"
            @change="onSelectAccessor"
          >
            <a-select-option
              v-for="(trainer, index) in trainers2"
              :key="index"
              :value="trainer.trainer_id"
            >
              {{ trainer.full_name_en }}
            </a-select-option>
          </a-select>
          <div class="invalid-feedback" v-if="errors.has('trainer_id_2')">
            {{ errors.first("trainer_id_2") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label>{{ $t("courseSkill.trainer3") }}</label>
          <a-select
            class="col-md-12"
            show-search
            option-filter-prop="children"
            allowClear
            v-model.number.trim="model.trainer_id_3"
            :class="{
              'is-invalid': errors.has('trainer_id_3'),
            }"
            @change="onSelectAccessor"
          >
            <a-select-option
              v-for="(trainer, index) in trainers3"
              :key="index"
              :value="trainer.trainer_id"
            >
              {{ trainer.full_name_en }}
            </a-select-option>
          </a-select>
          <div class="invalid-feedback" v-if="errors.has('trainer_id_3')">
            {{ errors.first("trainer_id_3") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 tw-flex tw-justify-end tw-space-x-3">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t("cancel") }}
          </ts-button>
          <ts-button
            v-if="!isUpdate"
            color="primary"
            outline
            :waiting="waiting"
            :disabled="waiting"
            @click.prevent="onSaveAddNew"
          >
            {{ $t("saveAddNew") }}</ts-button
          >
          <ts-button
            v-if="!isUpdate"
            color="primary"
            :waiting="waiting"
            :disabled="waiting"
            @click.prevent="onSave"
            >{{ $t("save") }}</ts-button
          >
          <ts-button
            v-if="isUpdate"
            :waiting="waiting"
            :disabled="waiting"
            color="primary"
            @click.prevent="onUpdate"
            >{{ $t("update") }}</ts-button
          >
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { includes, isEmpty } from "lodash";
import { Errors } from "form-backend-validation";
import { mapActions, mapState } from "vuex";
export default {
  name: "courseSkillForm",
  data() {
    return {
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      showBrowseFileBotton: false,
      trainers_1: [],
      trainers_2: [],
      trainers_3: [],
      model: {
        examination_event: null,
        level_skill_id: null,
        room: null,
        trainer_id: null,
        trainer_id_2: null,
        trainer_id_3: null,
      },
    };
  },
  computed: {
    ...mapState("academic/courseSkill", ["edit_data", "formViewDatas"]),
    isUpdate() {
      return !isEmpty(this.edit_data);
    },
    trainers1() {
      if (this.model.trainer_id_2 || this.model.trainer_id_3) {
        return this.trainers_1.filter(
          (i) =>
            !includes(
              [this.model.trainer_id_3, this.model.trainer_id_2],
              i.trainer_id
            )
        );
      }
      return this.trainers_1;
    },
    trainers2() {
      if (this.model.trainer_id || this.model.trainer_id_3) {
        return this.trainers_2.filter(
          (i) =>
            !includes(
              [this.model.trainer_id, this.model.trainer_id_3],
              i.trainer_id
            )
        );
      }
      return this.trainers_2;
    },
    trainers3() {
      if (this.model.trainer_id || this.model.trainer_id_2) {
        return this.trainers_3.filter(
          (i) =>
            !includes(
              [this.model.trainer_id, this.model.trainer_id_2],
              i.trainer_id
            )
        );
      }
      return this.trainers_3;
    },
  },
  async created() {
    await this.fetchFormViewModel({ params: {}, index: undefined });
    this.setEditData();
  },
  methods: {
    ...mapActions("academic/courseSkill", ["getFormViewData"]),
    async fetchFormViewModel({ params, index }) {
      this.waiting = true;
      await this.getFormViewData({
        index: index,
        params: params,
      });
      this.trainers_1 = this.formViewDatas["trainers"];
      this.trainers_2 = this.formViewDatas["trainers"];
      this.trainers_3 = this.formViewDatas["trainers"];
      this.waiting = false;
    },
    onSelectAccessor(id) {
      this.formViewDatas["trainers"] = this.formViewDatas["trainers"].filter(
        function (i) {
          return i.trainer_id != id;
        }
      );
    },

    async onSave() {
      this.waiting = true;
      this.$store
        .dispatch("academic/courseSkill/store", this.model)
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("fetchData");
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    async onSaveAddNew() {
      this.errors = new Errors();
      this.waiting = true;
      this.$store
        .dispatch("academic/courseSkill/store", Object.assign({}, this.model))
        .then(async (response) => {
          this.$notify({
            type: "success",
            text: response.message,
          });
          this.clearEdit();
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    async onUpdate() {
      this.waiting = true;
      this.$store
        .dispatch("academic/courseSkill/update", {
          id: this.model.course_skill_id,
          data: this.model,
        })
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.course_skill_id = this.edit_data.course_skill_id;
        this.model.examination_event = this.edit_data.examination_event;
        this.model.level_skill_id = this.edit_data.level_skill_id;
        this.model.trainer_id = this.edit_data.trainer_id;
        this.model.trainer_id_2 = this.edit_data.trainer_id_2;
        this.model.trainer_id_3 = this.edit_data.trainer_id_3;
        this.model.room = this.edit_data.room;
      }
    },
    clearEdit() {
      this.model.course_skill_id = null;
      this.model.examination_event = null;
      this.model.level_skill_id = null;
      this.model.trainer_id = null;
      this.model.trainer_id_2 = null;
      this.model.trainer_id_3 = null;
      this.model.room = null;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>